import { Button, Flex, Spinner, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { Navigate } from 'react-router-dom'
import { useLanguage } from '../hooks/utility/useLanguage'
import { useUser } from '../hooks/auth/useUser'

interface SuperuserRouteProps {
  children: React.ReactElement
}

const SuperuserRoute: React.FC<SuperuserRouteProps> = ({ children }) => {
  const { data: user, isLoading, isError, error } = useUser()
  const { t } = useLanguage()

  if (isLoading) {
    return (
      <Flex justify='center' align='center' height='100vh'>
        <VStack spacing={4}>
          <Spinner size='xl' color='primary' thickness='4px' />
          <Text color='gray.600'>{t('common.loading')}</Text>
        </VStack>
      </Flex>
    )
  }

  if (isError) {
    return (
      <Flex justify='center' align='center' height='100vh'>
        <VStack spacing={4}>
          <Text color='red.500' fontSize='lg'>
            {error instanceof Error ? error.message : t('common.error')}
          </Text>
          <Button onClick={() => window.location.reload()}>{t('common.tryAgain')}</Button>
        </VStack>
      </Flex>
    )
  }

  // Only redirect if we have user data AND they're not a superuser
  // Don't redirect during loading state
  if (user && !user.is_superuser) {
    return <Navigate to='/library' replace />
  }

  return children
}

export default SuperuserRoute
